/**
 * Checklist Template Mapper
 * Maps between API DTOs and Domain Entities
 */

import {
  ChecklistTemplateDTO,
  ChecklistTemplateItemDTO,
  TemplateResponseDTO,
} from "../models/ChecklistTemplateDTOs";
import {
  ChecklistTemplateEntity,
  ChecklistTemplateItemEntity,
} from "../../domain/entities/ChecklistTemplateEntity";
import { parseMonthEndChecklistItemWorkflowStatus } from "../../../../shared/constants/monthEndChecklist";

export class ChecklistTemplateMapper {
  /**
   * Convert ChecklistTemplateDTO to ChecklistTemplateEntity
   */
  static toTemplateEntity(dto: ChecklistTemplateDTO): ChecklistTemplateEntity {
    return {
      id: dto.id,
      name: dto.name,
      description: dto.description,
      is_active: dto.is_active,
      created_by: dto.created_by,
      created_at: dto.created_at,
      updated_at: dto.updated_at,
    };
  }

  /**
   * Convert ChecklistTemplateItemDTO to ChecklistTemplateItemEntity
   */
  static toTemplateItemEntity(
    dto: ChecklistTemplateItemDTO
  ): ChecklistTemplateItemEntity {
    // Parse JSON strings to arrays if needed
    let taskGuidance: string[] = [];
    if (typeof dto.task_guidance === "string") {
      try {
        taskGuidance = JSON.parse(dto.task_guidance);
      } catch {
        taskGuidance = [];
      }
    } else if (Array.isArray(dto.task_guidance)) {
      taskGuidance = dto.task_guidance;
    }

    let acceptedProofTypes: string[] = ["screenshot"]; // Default
    if (typeof dto.accepted_proof_types === "string") {
      try {
        acceptedProofTypes = JSON.parse(dto.accepted_proof_types);
      } catch {
        acceptedProofTypes = ["screenshot"];
      }
    } else if (Array.isArray(dto.accepted_proof_types)) {
      acceptedProofTypes = dto.accepted_proof_types;
    }

    const requiresProof =
      dto.requires_proof === undefined || dto.requires_proof === null
        ? true
        : Boolean(
            typeof dto.requires_proof === "string"
              ? dto.requires_proof === "1" || dto.requires_proof === "true"
              : dto.requires_proof
          );

    return {
      id: dto.id,
      template_id: dto.template_id,
      is_active: dto.is_active, // ADD THIS
      accounting_area: dto.accounting_area,
      title: dto.title,
      description: dto.description,
      task_guidance: taskGuidance,
      accepted_proof_types: acceptedProofTypes,
      requires_proof: requiresProof,
      display_order: dto.order_index || 0,
      priority:
        dto.priority === "high" ||
        dto.priority === "medium" ||
        dto.priority === "low"
          ? dto.priority
          : "medium",
      status: parseMonthEndChecklistItemWorkflowStatus(dto.status),
      created_at: dto.created_at,
      updated_at: dto.updated_at,
    };
  }

  /**
   * Convert TemplateResponseDTO to ChecklistTemplateEntity or null
   */
  static toTemplateEntityFromResponse(
    dto: TemplateResponseDTO
  ): ChecklistTemplateEntity | null {
    if (!dto.data) {
      return null;
    }
    return this.toTemplateEntity(dto.data);
  }

  /**
   * Convert array of ChecklistTemplateItemDTO to ChecklistTemplateItemEntity array
   */
  static toTemplateItemEntityArray(
    items: ChecklistTemplateItemDTO[]
  ): ChecklistTemplateItemEntity[] {
    return (items || []).map((itemDto) =>
      this.toTemplateItemEntity(itemDto)
    );
  }
}

